'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = require('./Tabs');

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

var _TabBar = require('./TabBar');

Object.defineProperty(exports, 'TabBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TabBar).default;
  }
});

var _Tab = require('./Tab');

Object.defineProperty(exports, 'Tab', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tab).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl/lib/Tabs/index.js
// module id = 640
// module chunks = 0